// src/app/services/organisation.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CorporatePropertyAiSummary } from '../domain/Ai/corporate-property-ai-summary';

@Injectable({ providedIn: 'root' })
export class OrganisationService {
   constructor(private http: HttpClient) {}

   getOrganisationAiSummary(
      organisationId: number,
      startDate: string,
      endDate: string
   ): Observable<CorporatePropertyAiSummary[]> {
      return this.http.get<CorporatePropertyAiSummary[]>(
         `${environment.apiEndpoint}/organisation/${encodeURIComponent(
            organisationId
         )}/ai`,
         {
            params: {
               startDate,
               endDate
            }
         }
      );
   }
}
